import { Component, ViewContainerRef, OnInit ,ChangeDetectorRef, ElementRef, ViewChild, OnDestroy,AfterViewInit} from '@angular/core';
import { ConfigService } from './config/ConfigService';
import { BlockUIService } from './shared/services/blockui.service';
import { RolesPermissionsService } from './shared/services/rolespermissions.service';
//import { Idle, DEFAULT_INTERRUPTSOURCES } from 'ng2-idle';
import { SessionService } from './shared/services/session.service';
import { NgRedux } from '@angular-redux/store';
import { IState, initialState, authenticationValidationReducer } from './Session/authenticationvalidation';
import { VersionCheckService } from './HashPolling/version-check.service';
import { genericConfigValues,ApplicationIds } from './shared/globals';
import { ClientBannerService } from './ClientBanner/clientBanner.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NotificationService } from './shared/services/notification.service';
import {  Subscription } from 'rxjs';
import { AppFooterResetService } from './shared/sharedservices/appFooterReset.service';

@Component({
    selector: 'fetch-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit,OnDestroy {
    appVersion: string = "";
    copyrightYear: string = "";
    privacyPolicyLink = "";
    frequency: any;

    applicationIds:ApplicationIds;
    clientBannerTxt:string="";
    additionalTextBanner:string="";
    displayBanner:boolean=false;
    
    private viewContainerRef: ViewContainerRef;
    loading: Boolean;
    loadingFromProxy: boolean = false;
    public notificationsOptions = {
        position: ['bottom', 'right'],
        timeOut: 5000,
        preventDuplicates: true,
        preventLastDuplicates: 'visible'
    };
    display: boolean = false;
    safeEditorContent:SafeHtml;
     private subscription!: Subscription;

    constructor(viewContainerRef: ViewContainerRef, private blockUIService: BlockUIService, private configService: ConfigService,
        private sessionService: SessionService, session: NgRedux<IState>,
        private versionCheckService : VersionCheckService,
        private changeDetector: ChangeDetectorRef,
        private clientBannerService:ClientBannerService,
        private sanitizer: DomSanitizer,
        private notification: NotificationService,
        private appfooterResetService:AppFooterResetService) {
        session.configureStore(authenticationValidationReducer, initialState);
    }
    ngOnInit() {
        var baseUrl = location.protocol + "//" + location.host + location.pathname;
        var url = baseUrl+'/assets/version.json';

        this.versionCheckService.initVersionCheck(url,false);

        this.blockUIService.blockUIEvent.subscribe(event => this.blockUnBlockUI(event));

        this.blockUIService.blockUIEvent.emit({
            value: false
        });
        this.appVersion = this.configService.get("AppVersion");
        this.copyrightYear = this.configService.get("copyrightYear");
        this.privacyPolicyLink = genericConfigValues.privacyPolicyLink;

        //this is added to accomodate proxy login page. We should not show this footer when the loading.
        if (this.sessionService.getItem('uname') != null && this.sessionService.getItem('upwd') != null) {
            this.loadingFromProxy = true;
        }
        this.getClientBanner();
        
    }

    ngAfterContentChecked(): void {
        this.changeDetector.detectChanges();
    }
    ngAfterViewInit():void{
         this.subscription = this.appfooterResetService.changebanner$.subscribe(() => {
         this.getClientBanner();
        });
      }

    private blockUnBlockUI(event) {
        this.loading = event.value;
    }

    openPrivacyPolicyPage() {
        window.open(this.privacyPolicyLink);
    }

    openTermsandConditionPage() {
        this.display = true;
    }
    closeDialog() {
        this.display = false;

    }
    openBannerAdditionalInfo()
    {
      this.safeEditorContent = this.sanitizer.bypassSecurityTrustHtml(this.additionalTextBanner);
      this.displayBanner=true;
    }
    getClientBanner()
    {
        this.clientBannerTxt= '';
        this.additionalTextBanner='';
        var isExternal = this.configService.get("isExternal");
        var applicationId=isExternal=="1"?ApplicationIds.fetchExternal:ApplicationIds.fetchInternal;
         this.clientBannerService.getActiveBannerOnApplication(applicationId).
         subscribe(response=> {
        if(response.isSuccessful){
        if(response.banner != null && response.banner.bannerText.length>0){
            this.clientBannerTxt= response.banner.bannerText;
            this.additionalTextBanner= response.banner.additionalText;
        }
        }
        else if(response.errorMessages !=null)
            this.notification.showError(response.errorMessages[0], "Error");
    },
        error => this.notification.showError(error, "Error"));
    }
    closeAdditionalTextDialog()
    {
        this.displayBanner=false;
    }
    ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
